module.exports = __webpack_public_path__ + "img/pe.90cf9b5.svg";